import Content from './Content';
import style from '../css/Report.module.css';
import React, { useRef, useState, useEffect, useContext } from 'react';
import axios from 'axios';

import Side from './SideRC';
import ReportCard from "./ReportCard";

import { TokenContext } from "./TokenContext";
import Loader from './Loader';

function ViewContainerRC({ jsonData }) {
  const [pdfUrl, setPdfUrl] = useState(null); // PDF URL 상태 관리

  const [studentId, setStudentId] = useState(jsonData?.jsonData?.jsonData?.studentUID || 0); // 🔹 학생 ID (읽기 전용)
  const [startDate, setStartDate] = useState(jsonData?.jsonData?.jsonData?.defaultDate.startDate || ""); // 🔹 시작 날짜
  const [endDate, setEndDate] = useState(jsonData?.jsonData?.jsonData?.defaultDate.endDate || ""); // 🔹 종료 날짜
  const { bearerToken, _csrf } = useContext(TokenContext); // Context 사용

  const [loading, setLoading] = useState(false); // 로딩 상태
  const [error, setError] = useState(null); // 에러 상태
  const [data, setData] = useState([]);
  const [selectedIndexes, setSelectedIndexes] = useState([]); // 선택된 데이터의 인덱스

  useEffect(() => {
    // 🔹 jsonData 값이 변경되면 초기 상태를 업데이트
    if (jsonData) {
      setStudentId(jsonData?.jsonData?.jsonData?.studentUID);
      setStartDate(jsonData?.jsonData?.jsonData?.defaultDate.startDate);
      setEndDate(jsonData?.jsonData?.jsonData?.defaultDate.endDate);
    }
  }, [jsonData]);

  // '성적표' 에서는 필요없는 함수
  const handleGeneratePDF = async (bodyData) => {

    // endpoint : /report/api/getData/generate-report
    // method : post
    // body : { userId, layoutType }
    // *layoutType
    // 1 ==> 단어 1단
    // 2 ==> 단어 2단
    // 1 ==> 문장 1단
    // 2 ==> 문장 상하

    // const URL = 'https://gentle-smart-wolf.ngrok-free.app';
    // const URL = 'https://smoothly-becoming-llama.ngrok-free.app';

    const endpoint = "/report/api/getData/generate-report"; // 가상의 서버 주소
    // const endpoint = `${URL}/report/start/startData`; // 가상의 서버 주소

    try {
      const response = await axios.post(endpoint,
        bodyData,
        {
        }, {
        withCredentials: true, // 쿠키 포함 옵션
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${bearerToken}`,
          'x-csrf-token': `${_csrf}`,
        }
      });

      const data = await response.data;

      if (data.result) { // 성공 상태 확인
        const getUrl = data.data; // 서버에서 반환된 PDF URL
        setPdfUrl(`${getUrl}`); // 서버에서 받은 PDF URL 설정
        //window.open(`http://localhost:3030${getUrl}`, '_blank');          
      } else {
        alert('PDF 생성에 실패했습니다.');
      }
    } catch (error) {
      console.error('PDF 요청 중 오류 발생:', error);
    }
  }

  const selectAll = () => {
    setSelectedIndexes(data.map((_, index) => index));
  };

  const deselectAll = () => {
    setSelectedIndexes([]);
  };

  const toggleSelection = (index) => {
    setSelectedIndexes((prev) => {
      if (prev.includes(index)) {
        return prev.filter((i) => i !== index);
      } else {
        return [...prev, index];
      }
    });
  };

  const reportCardRef = useRef(null);

  // test_result.XXX_step_count 배열 정렬하기
  // 1) XXX_step_num 순서가 기본정렬
  // 2) XXX_step_num 값이 모두 0일때, XXX_step_id 순서로 정렬시킨다.
  const reorderSrcData = (srcData) => {
    return srcData.map(item => {
      const resultType = item.result_type;
      const testResult = item.test_result;

      // 🔸 test_result 자체가 null이면 그대로 유지
      if (testResult === null) {
        return { ...item, test_result: null };
      }

      let stepCountKey, stepNumKey, stepIdKey;

      switch (resultType) {
        case "word":
          stepCountKey = "word_step_count";
          stepNumKey = "word_step_num";
          stepIdKey = "word_step_id";
          break;
        case "sentence":
          stepCountKey = "sentence_step_count";
          stepNumKey = "sentence_step_num";
          stepIdKey = "sentence_step_id";
          break;
        case "test":
          stepCountKey = "test_step_count";
          stepNumKey = "test_step_num";
          stepIdKey = "test_step_id";
          break;
        default:
          return item; // 정렬 대상 아님
      }

      const stepArray = testResult[stepCountKey];

      // 🔸 stepArray가 없거나 비어 있으면 그대로 반환
      if (!Array.isArray(stepArray) || stepArray.length === 0) {
        return item;
      }

      // 🔸 조건 1, 2에 따른 정렬
      const hasValidStepNum = stepArray.some(step => step[stepNumKey] !== 0 && step[stepNumKey] !== null);
      const sortedSteps = [...stepArray].sort((a, b) => {
        const key = hasValidStepNum ? stepNumKey : stepIdKey;
        return a[key] - b[key];
      });

      return {
        ...item,
        test_result: {
          ...testResult,
          [stepCountKey]: sortedSteps
        }
      };
    });
  };

  // 서버 요청 핸들러
  const fetchReportData = async () => {
    setLoading(true); // 로딩 시작
    setError(null); // 이전 에러 초기화

    // ### 성적표 데이타 받아오기 ###
    // endpoint  : /report/api/getData/reportCard
    // method : post
    // body : { studentId, startDate, endDate }

    // const URL = 'https://gentle-smart-wolf.ngrok-free.app';
    // const URL = 'https://smoothly-becoming-llama.ngrok-free.app';

    // const endpoint = "/report/api/getData/reportCard"; // 가상의 서버 주소
    // const endpoint = `${URL}/report/api/getData/reportCard`; // 가상의 서버 주소
    const endpoint = `/report/api/getData/reportCard`; // 가상의 서버 주소
    const requestBody = {   // 나중에 확인 필요
      studentId: studentId, // 가상의 studentId
      startDate: startDate, // 가상의 시작 날짜
      endDate: endDate, // 가상의 종료 날짜
      // studentId: 720, // 가상의 studentId
      // startDate: '2025-01-01', // 가상의 시작 날짜
      // endDate: '2025-12-31', // 가상의 종료 날짜
    };

    try {
      const response = await axios.post(endpoint,
        requestBody,
        {
          withCredentials: true, // 쿠키 포함 옵션
          headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${bearerToken}`,
            'x-csrf-token': `${_csrf}`,
          },
        });

      if (response) {
        if (response.data.result) {
          // setData(response.data.data); // 받은 데이터 저장
          const srcData2 = reorderSrcData(response.data.data);
          setData(srcData2); // 수정된 데이터 저장
          // ('==> 성공 ');
        } else {
          // ('==> 실패 1 ');
        }
      } else {
        // ('==> 실패 2 ');
      }
    } catch (err) {
      setError(err.message || "오류가 발생했습니다."); // 에러 저장
    } finally {
      setLoading(false); // 로딩 종료
    }
  };

  if (error) {
    // console.error(error);
  }

  return (
    <div className={style.viewContainer}>

      {loading && <Loader />}

      <Side
        fetchReportData={fetchReportData}
        sendHTMLToServer={(bodyData) => reportCardRef.current?.sendHTMLToServer(bodyData)}
        selectAll={selectAll}
        deselectAll={deselectAll}
        handleGeneratePDF={handleGeneratePDF}
        jsonData={jsonData?.jsonData}
        setPdfUrl={setPdfUrl} // 🔹 PDF URL 변경 함수 전달
        pdfUrl={pdfUrl}
        loading={loading}
        setLoading={setLoading}

        studentId={studentId} // 🔹 읽기 전용
        startDate={startDate} // 🔹 Side에서 변경 가능
        setStartDate={setStartDate}
        endDate={endDate} // 🔹 Side에서 변경 가능
        setEndDate={setEndDate}
      />

      {pdfUrl ? (
        <Content pdfUrl={pdfUrl} />
      ) : (
        <div className={style.contentContainer} style={{ width: "100%", height: "100%" }}>
          <div className={style.viewer} style={{ width: "100%", height: "100%", overflow: "auto" }}>
            {/* 🔹 pdfUrl이 있으면 Content 표시, 없으면 ReportCard 표시 */}

            <div style={{ width: "100%", height: "100%", display: "flexGrow", justifyContent: "center" }}>
              <ReportCard
                ref={reportCardRef}
                data={data}
                selectedIndexes={selectedIndexes}
                // setSelectedIndexes={setSelectedIndexes}
                toggleSelection={toggleSelection}
                startDate={startDate}
                endDate={endDate}
              />
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

export default ViewContainerRC;